import { AccountPageBloc, AccountPageState } from "@uiview/pages/profile/account/AccountPageBloc";

export class AccountMobileBloc {
  accountPageBloc: AccountPageBloc;
  constructor() {
    const accountState = new AccountPageState();
    this.accountPageBloc = new AccountPageBloc(accountState);
  }
}
